module.exports = __webpack_public_path__ + "static/media/fidelizacion.7a78e7fb.svg";